module.exports = __webpack_public_path__ + "static/media/id.3551f508.png";